import React from 'react';
import { action, observable, values, get, set, keys } from "mobx";

export default class SelectTransformer {

    
    transform(value, some, row) {
        
        const la = observable.box();

        //treba mi table adapter

        
        console.log( row );
        console.log( observable(row.webcollection) );

        return (
            <div style={{color: 'red'}}>
                <select onChange={(ev)=>{console.log('do we have access to the whole row of data?', value, ev)}} name="select custom" id="">
                    <option value="some">Option</option>
                    <option value="some1">Option2</option>
                    <option value="some3">Option 3</option>
                    <option value="some4">Option 4</option>
                </select>
            </div>
        );
    }
}